import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import { Form as FinalForm } from 'react-final-form';
import { FormContainer } from '@spark/ui-components/components/form/FormElements';
import DynamicForm from '@spark/ui-components/components/form/DynamicForm';
import { formStructure, formSections } from '../../../../components/formConfig';
import { useDetalhesTab } from '../../../hooks/useDetalhesTab';
import * as S from '../../../../components/index-styled';

const DetalhesTab = ({ depotId, depot }) => {

  const { initialValues, anexos, anexosLoading } = useDetalhesTab(depotId, depot);

  const isColetaAnexo = (anexo) => {
    const nome = (anexo?.NomeArquivo || anexo?.NomeOriginal || '').toLowerCase();
    return nome.startsWith('coleta');
  };

  const isDevolucaoAnexo = (anexo) => {
    const nome = (anexo?.NomeArquivo || anexo?.NomeOriginal || '').toLowerCase();
    return nome.startsWith('devolucao');
  };

  const isDepotAnexo = (anexo) => !isColetaAnexo(anexo) && !isDevolucaoAnexo(anexo);

  const renderAnexos = (lista = []) => {
    if (anexosLoading) return <p style={{ marginTop: 16 }}>Carregando anexos...</p>;
    if (!lista?.length) return <p style={{ marginTop: 16 }}>Nenhum anexo enviado.</p>;

    return (
      <S.AnexosGrid>
        {lista.map((anexo) => {
          const src = anexo.UrlArquivo || '';
          const nomeOriginal = anexo.NomeArquivo || anexo.NomeOriginal || 'Anexo';
          const nome = nomeOriginal.replace(/^(coleta|devolucao)\s*-\s*/i, '').trim();
          return (
            <S.AnexoItem key={anexo.Id}>
              
              <S.Caption>
                <S.FileTag
                  type="button"
                  onClick={() => {
                    if (src) {
                      window.open(src, '_blank', 'noopener');
                    }
                  }}
                  title={nome}
                >
                  {nome}
                </S.FileTag>
              </S.Caption>
            </S.AnexoItem>
          );
        })}
      </S.AnexosGrid>
    );
  };

  return (
    <>

      <Row>
        <Col md={12}>
          <FinalForm
            onSubmit={(e) => e}
            initialValues={initialValues}
            render={({ handleSubmit }) => (
              <FormContainer onSubmit={handleSubmit}>
                <DynamicForm
                  structure={formStructure}
                  sections={formSections(initialValues)}
                  isViewMode={true}
                  readOnly={true}
                />
              </FormContainer>
            )}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={12}>
          <Card>
            <CardBody>
              <CardTitle>Anexos da Coleta</CardTitle>
              <div>
                {renderAnexos(anexos?.filter(isColetaAnexo))}
              </div>
              <CardTitle style={{ marginTop: 20 }}>Anexos da Devolução</CardTitle>
              <div style={{ marginTop: 10 }}>
                {renderAnexos(anexos?.filter(isDevolucaoAnexo))}
              </div>
              <CardTitle style={{ marginTop: 20 }}>Anexos do depot</CardTitle>
              <div style={{ marginTop: 10 }}>
                {renderAnexos(anexos?.filter(isDepotAnexo))}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </>
  );
};

export default DetalhesTab;
